import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation, ApprovalTypes } from '../../types';
import { unreachableFallback } from 'ui-product-approvals-common/utils/unreachableFallback';
import { jsx as _jsx } from "react/jsx-runtime";
const ApprovalModalHeaderI18nApprove = ({
  approvalType
}) => {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.MARKETING_EMAIL"
      });
    case 'SITE_PAGE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.SITE_PAGE"
      });
    case 'LANDING_PAGE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.LANDING_PAGE"
      });
    case 'BLOG_POST':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.BLOG_POST"
      });
    case 'DEAL':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.DEAL"
      });
    case 'KNOWLEDGE_ARTICLE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.KNOWLEDGE_ARTICLE"
      });
    case 'QUOTE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.QUOTE"
      });
    case 'SOCIAL_BROADCAST':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.SOCIAL_BROADCAST"
      });
    case 'CONNECTED_APP':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.APPROVE.CONNECTED_APP"
      });
    default:
      return unreachableFallback(approvalType, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.unhandled.approvalType"
      }));
  }
};
export const ApprovalModalHeaderI18n = ({
  approvalType,
  approvalOperation
}) => {
  switch (approvalOperation) {
    case ApprovalOperation.REQUEST:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.REQUEST"
      });
    case ApprovalOperation.RECALL:
    case ApprovalOperation.CANCEL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalHeader.CANCEL"
      });
    case ApprovalOperation.REJECT:
      {
        if (approvalType === ApprovalTypes.DEAL) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalHeader.REJECT.DEAL"
          });
        }
        if (approvalType === ApprovalTypes.QUOTE) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalHeader.REJECT.QUOTE"
          });
        }
        if (approvalType === ApprovalTypes.SOCIAL_BROADCAST) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalHeader.REJECT.SOCIAL_BROADCAST"
          });
        }
        if (approvalType === ApprovalTypes.CONNECTED_APP) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalHeader.REJECT.CONNECTED_APP"
          });
        }
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalHeader.REJECT.default"
        });
      }
    case ApprovalOperation.APPROVE:
      return /*#__PURE__*/_jsx(ApprovalModalHeaderI18nApprove, {
        approvalType: approvalType
      });
    default:
      return unreachableFallback(approvalOperation, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.unhandled.approvalOperation"
      }));
  }
};